export const BuscarPor = Object.freeze({
    comercio: 1,
    beneficio: 2,
    categoria: 3,
    localidad: 4,
});

export const EstadoLogo = Object.freeze({ vacio: 1, nuevo: 2, original: 3 });

export const EstadoPromesa = Object.freeze({
    parada: 0,
    trabajando: 1,
    exito: 2,
    error: 3,
})

export const OrdenarPor = Object.freeze({
    relevancia: 1,
    novedad: 2,
    calificacion: 3,
    // No implementado, falta ajustar la estructura de beneficios para 
    // poder trabajar con este orden
    //mayorDescuento: 4,
});

/** Utilizado para indicar el tamaño de la pantalla */
export const TipoPantalla = Object.freeze({
    ambas: "ambas",
    chica: "chica",
    grande: "grande",
});